import App from './views/App.vue';

export default [
  {
    path: '/',
    name: 'app',
    component: App,
    redirect: '/index',
    children: [
      {
        path: '/index',
        name: 'index',
        component: () => import('./views/Index/Index.vue'),
        meta: {
          title: '首页'
        }
      },
      {
        path: '/detail',
        name: 'detail',
        component: () => import('./views/Index/Detail.vue'),
        meta: {
          title: '详情'
        }
      },
    ]
  }
];
